import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Changes target "src" attribute value and resets it to the original on disconnect.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Targets
 * -------
 *
 * element - (required) - element to change src attribute value
 *
 * Values
 * -------
 *
 * src - (required) - new src attribute value
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="src-change"
 *   data-src-change-src-value="https://example.com"
 *   data-action="mouseover->src-change#change mouseout->src-change#reset"
 * >
 *   <img src="" data-src-change-target="element" />
 * </div>
 *
 * ------------------------------------------------------------
 *
 * <div
 *   data-controller="src-change"
 *   data-src-change-src-value="https://example.com"
 * >
 *   <button data-action="click->src-change#change"></button>
 *   <iframe data-src-change-target="element"></iframe>
 * </div>
 */
export class SrcChange extends Controller {
    static targets = ['element'];
    static values = { src: String };
    connect() {
        this.originalSrc = this.elementTarget.src;
    }
    change() {
        this.elementTarget.src = this.srcValue;
    }
    reset() {
        if (!this.originalSrc)
            return;
        this.elementTarget.src = this.originalSrc;
    }
    disconnect() {
        this.reset();
    }
    teardown() {
        this.reset();
    }
}
